export interface WindowsApplicationState {
	applications: string[];
	areApplicationsSet: boolean;
	promptLogin: boolean;
}

export function createWindowsApplicationState(): WindowsApplicationState {
	return { applications: [], areApplicationsSet: false, promptLogin: true };
}
